import React from 'react';

import VenueFeatures from './component';

export default React.memo(VenueFeatures);
